import ID from '../models/ID'
import TacticPlatform from '../models/TacticPlatform'
import {lookupByIds} from './lookupByIds'

// Display string for a tactic's platforms: names in the tactic's order, unknown IDs skipped
export function platformNamesForIds(platforms: TacticPlatform[], ids: ID[]): string {
  const platformsById = new Map<number, TacticPlatform>(
    platforms.map((platform) => [platform.id.intID, platform])
  )
  return lookupByIds(platformsById, ids)
    .map((platform) => platform.name)
    .join(', ')
}
